export default "__VITE_ASSET__BsdoDTf5__"